import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { ButtonInputComponent } from './button-input/button-input.component';
import { ChatActivationTableComponent } from './chat-activation-table/chat-activation-table.component';
import { ColorPaletteSelectorComponent } from './color-palette-selector/color-palette-selector.component';
import { DashboardFilterComponent } from './dashboard-filter/dashboard-filter.component';
import { HomeWidgetDirective } from './dashboard-widgets/dashboard-widget.directive';
import { HomeWidgetsModule } from './dashboard-widgets/dashboard-widgets.module';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { GameModesComponent } from './game-modes/game-modes.component';
import { GlossaryLinkDirective } from './glossary-link/glossary-link.directive';
import { IconExchangeComponent } from './icon-exchange/icon-exchange.component';
import { IconSelectComponent } from './icon-select/icon-select.component';
import { InputSelectorComponent } from './input-selector/input-selector.component';
import { LogoExchangeComponent } from './logo-exchange/logo-exchange.component';
import { MediaExplorerComponent } from './media-explorer/media-explorer.component';
import { MediaModalComponent } from './media-modal/media-modal.component';
import { NgbdModalBasic } from './modal/modal.component';
import { NestedPathSelectorComponent } from './nested-path-selector/nested-path-selector.component';
import { NodeNavbarComponent } from './node-navbar/node-navbar.component';
import { NodePropertiesComponent } from './node-properties/node-properties.component';
import { NodeResourceHeaderComponent } from './node-resource-header/node-resource-header.component';
import { ObjectEditorComponent } from './object-editor/object-editor.component';
import { PathLabelComponent } from './path-label/path-label.component';
import { PathSelectorComponent } from './path-selector/path-selector.component';
import { PencilInputComponent } from './pencil-input/pencil-input.component';
import { PermissionTableComponent } from './permissions/permission-table/permission-table.component';
import { PermissionTogglesComponent } from './permissions/permission-toggles/permission-toggles.component';
import { PermissionVerbToggleComponent } from './permissions/verb-toggle/verb-toggle.component';
import { QuestionComponent } from './question/question.component';
import { ResourceIconComponent } from './resource-icon/resource-icon.component';
import { RoleSelectorComponent } from './role-selector/role-selector.component';
import { RoleSidebarComponent } from './role-sidebar/role-sidebar.component';
import { ResizeHandleDirective } from './sidebar/resize-handle/resize-handle.directive';
import { SidebarSegmentComponent } from './sidebar/segment/segment.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TypeFilterComponent } from './type-filter/type-filter.component';
import { VimeoExplorerComponent } from './vimeo-explorer/vimeo-explorer.component';
import { VimeoModalComponent } from './vimeo-modal/vimeo-modal.component';
import { WikiLinkComponent } from './wiki-link/wiki-link.component';
import { WikiLinkModalComponent } from './wiki-link-modal/wiki-link-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FontAwesomeModule,
    FormsModule,
    InfiniteScrollModule,
    CKEditorModule,
    ReactiveFormsModule,
    HomeWidgetsModule
  ],
  declarations: [
    SidebarComponent,
    NgbdModalBasic,
    QuestionComponent,
    GameModesComponent,
    SidebarSegmentComponent,
    WikiLinkComponent,
    WikiLinkModalComponent,
    IconSelectComponent,
    MediaExplorerComponent,
    MediaModalComponent,
    ResourceIconComponent,
    TypeFilterComponent,
    NodePropertiesComponent,
    FileUploadComponent,
    NestedPathSelectorComponent,
    PathLabelComponent,
    PathSelectorComponent,
    ColorPaletteSelectorComponent,
    VimeoExplorerComponent,
    VimeoModalComponent,
    PencilInputComponent,
    GlossaryLinkDirective,
    InputSelectorComponent,
    ButtonInputComponent,
    PermissionTableComponent,
    PermissionTogglesComponent,
    PermissionVerbToggleComponent,
    ChatActivationTableComponent,
    RoleSidebarComponent,
    NodeNavbarComponent,
    ResizeHandleDirective,
    NodeResourceHeaderComponent,
    RoleSelectorComponent,
    ObjectEditorComponent,
    DashboardFilterComponent,
    HomeWidgetDirective,
    LogoExchangeComponent,
    IconExchangeComponent
  ],
  exports: [
    SidebarComponent,
    SidebarSegmentComponent,
    NgbdModalBasic,
    QuestionComponent,
    GameModesComponent,
    WikiLinkComponent,
    WikiLinkModalComponent,
    IconSelectComponent,
    MediaExplorerComponent,
    ResourceIconComponent,
    MediaModalComponent,
    NodePropertiesComponent,
    NestedPathSelectorComponent,
    PathLabelComponent,
    PathSelectorComponent,
    FileUploadComponent,
    VimeoExplorerComponent,
    VimeoModalComponent,
    GlossaryLinkDirective,
    InputSelectorComponent,
    ButtonInputComponent,
    PermissionTableComponent,
    PermissionTogglesComponent,
    PermissionVerbToggleComponent,
    ChatActivationTableComponent,
    RoleSidebarComponent,
    NodeNavbarComponent,
    ResizeHandleDirective,
    NodeResourceHeaderComponent,
    RoleSelectorComponent,
    ObjectEditorComponent,
    DashboardFilterComponent,
    HomeWidgetDirective,
    LogoExchangeComponent,
    IconExchangeComponent
  ]
})
export class ComponentsModule {}
